import axios from 'axios';

const CLIENT_THROTTLE_MS = 5 * 60 * 1000;
const reportedAlerts = new Map<string, number>();

export interface SensitiveDataBlockedReport {
  blockedField: string;
  blockReason: string;
  pagePath: string;
  eventTitle?: string;
  eventSlug?: string;
  gtmContainerId?: string;
}

function getApiBaseUrl(): string {
  return import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080/api';
}

export async function reportSensitiveDataBlocked(report: SensitiveDataBlockedReport): Promise<void> {
  const throttleKey = `${report.pagePath}:${report.blockedField}:${report.blockReason}`;
  const lastReportedAt = reportedAlerts.get(throttleKey);
  const now = Date.now();

  if (lastReportedAt && now - lastReportedAt < CLIENT_THROTTLE_MS) {
    return;
  }

  reportedAlerts.set(throttleKey, now);

  try {
    await axios.post(`${getApiBaseUrl()}/analytics/gtm-security-alert`, report);
  } catch {
    return;
  }
}
